import { render, staticRenderFns } from "./VerifyContentDialog.vue?vue&type=template&id=0c4e457c&scoped=true&"
import script from "./VerifyContentDialog.vue?vue&type=script&lang=js&"
export * from "./VerifyContentDialog.vue?vue&type=script&lang=js&"
import style0 from "./VerifyContentDialog.vue?vue&type=style&index=0&id=0c4e457c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e457c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
